import React from 'react';
import './TeamPage.scss';
import { TeamPageContent } from './components/team-page-content/TeamPageContent';

export const TeamPageAdmin = () => {
    return <TeamPageContent />;
};
